import React, { useState, useEffect } from "react";
import { Redirect, useHistory } from "react-router-dom";
import "./FormularioDiplomas.css";
import ReferenciaOnline from "../utilities/ReferenciaOnline";
import generarLineaCaptura from "../utilities/GenerarLineaCaptura";
import { usePagoVentanilla } from "../hooks/usePagoVentanilla";
import { plantelDeMatricula } from "../utilities/plantel";

const FormularioDiplomas = ({
  conceptos = [],
  alumno,
  precio,
  cambiarPrecio,
  cambiarPagar = () => {},
  cambiarDatosPago,
  cambiarTablaConceptos,
  tablaConceptos,
}) => {
  const history = useHistory();
  const { cargandoPdf, generarFolioTPV, guardarIntencionBD, descargarPdf } = usePagoVentanilla(alumno);

  const [conceptosSeleccionados, setConceptosSeleccionados] = useState({
    certificado: true,
    noAdeudo: true,
    servicioSocial: true,
  });
  const [numDiplomas, setNumDiplomas] = useState(0); 
  const [error, cambiarError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");
  const [esSoloVentanilla, setEsSoloVentanilla] = useState(false);
  const [fechaVencimiento, setFechaVencimiento] = useState("");
  // Evita volver a guardar la intencion en cada clic de "Descargar" (ya
  // guardada la primera vez, los clics siguientes solo vuelven a descargar
  // el mismo PDF). Mismo patron que ya usa FormaPago.js.
  const [intencionGuardada, setIntencionGuardada] = useState(false);

  const esPaqueteCompleto = 
    conceptosSeleccionados.certificado && 
    conceptosSeleccionados.noAdeudo && 
    conceptosSeleccionados.servicioSocial;

  const handleCheckboxChange = (e) => {
    setConceptosSeleccionados({
      ...conceptosSeleccionados,
      [e.target.name]: e.target.checked,
    });
  };

  const getConceptoBD = (claveBuscada, fallbackPrecio, fallbackNombre) => {
    return conceptos.find(c => c.clave === claveBuscada) || { 
      precio: fallbackPrecio, 
      concepto: fallbackNombre, 
      clave: claveBuscada 
    };
  };

  const cCertificado = getConceptoBD("04", 250, "Certificado de terminación de estudios");
  const cNoAdeudo = getConceptoBD("37", 35, "Constancia de no adeudo (Sexto semestre)");
  const cServicio = getConceptoBD("38", 55, "Constancia de liberación de servicio social");
  const cDiploma = getConceptoBD("11", 50, "Diploma de Competencias");
  const cPaqueteBase = getConceptoBD("50", 340, "Paquete de Graduación Completo");

  useEffect(() => {
    let total = 0;
    let cuentaConceptos = 0;
    let tablaDesglose = [];

    const matriculaStr = String(alumno.codigo);
    const plantelOficialAlumno = plantelDeMatricula(matriculaStr);

    if (esPaqueteCompleto) {
      cuentaConceptos = 1; 
      const clavePaquete = (50 + numDiplomas).toString();
      const paqueteDinamico = getConceptoBD(clavePaquete, cPaqueteBase.precio + (numDiplomas * cDiploma.precio), `Paquete de Graduación + ${numDiplomas} Diplomas`);
      
      total = Number(paqueteDinamico.precio);
      tablaDesglose.push({ concepto: paqueteDinamico.concepto, clave: paqueteDinamico.clave, precio: paqueteDinamico.precio.toString() });
    } else {
      if (conceptosSeleccionados.certificado) {
        cuentaConceptos++;
        total += Number(cCertificado.precio);
        tablaDesglose.push({ concepto: cCertificado.concepto, clave: cCertificado.clave, precio: cCertificado.precio.toString() });
      }
      if (conceptosSeleccionados.noAdeudo) {
        cuentaConceptos++;
        total += Number(cNoAdeudo.precio);
        tablaDesglose.push({ concepto: cNoAdeudo.concepto, clave: cNoAdeudo.clave, precio: cNoAdeudo.precio.toString() });
      }
      if (conceptosSeleccionados.servicioSocial) {
        cuentaConceptos++;
        total += Number(cServicio.precio);
        tablaDesglose.push({ concepto: cServicio.concepto, clave: cServicio.clave, precio: cServicio.precio.toString() });
      }
      for (let i = 0; i < numDiplomas; i++) {
        cuentaConceptos++;
        total += Number(cDiploma.precio);
        tablaDesglose.push({ concepto: `${cDiploma.concepto} (${i + 1}/${numDiplomas})`, clave: cDiploma.clave, precio: cDiploma.precio.toString() });
      }
    }

    cambiarPrecio(total);
    const soloVentanilla = cuentaConceptos > 5;
    setEsSoloVentanilla(soloVentanilla);

    if (soloVentanilla) {
      const itemsBase = tablaDesglose.filter(item => ["04", "37", "38"].includes(item.clave));
      const itemsDiplomas = tablaDesglose.filter(item => item.clave === "11");

      let refBaseStr = "S/R", refBaseBBVA = "S/R";
      if (itemsBase.length > 0) {
        const importeBase = itemsBase.reduce((sum, item) => sum + Number(item.precio), 0);
        const clavesBase = itemsBase.map(item => item.clave);
        const datosRefBase = generarLineaCaptura(plantelOficialAlumno, clavesBase, matriculaStr, importeBase);
        refBaseStr = datosRefBase.banorte.lineaDeCaptura;
        refBaseBBVA = datosRefBase.bancomer.lineaDeCaptura;
        setFechaVencimiento(datosRefBase.banorte.fechaVencimientoStr);
      }

      let refDiplomasStr = "S/R", refDiplomasBBVA = "S/R";
      if (itemsDiplomas.length > 0) {
        const importeDiplomas = itemsDiplomas.reduce((sum, item) => sum + Number(item.precio), 0);
        const clavesDiplomas = itemsDiplomas.map(item => item.clave);
        const datosRefDiplomas = generarLineaCaptura(plantelOficialAlumno, clavesDiplomas, matriculaStr, importeDiplomas);
        refDiplomasStr = datosRefDiplomas.banorte.lineaDeCaptura;
        refDiplomasBBVA = datosRefDiplomas.bancomer.lineaDeCaptura;
        setFechaVencimiento(datosRefDiplomas.banorte.fechaVencimientoStr); 
      }

      // --- ASIGNACIÓN DE FOLIOS INDEPENDIENTES POR GRUPO ---
      const folioBase = generarFolioTPV();
      const folioDiplomas = generarFolioTPV();

      tablaDesglose = tablaDesglose.map((item, idx) => {
        const esDiploma = item.clave === "11";
        return {
          ...item,
          id: idx + 1,
          folioTPV: esDiploma ? folioDiplomas : folioBase, // <--- Folio individual por bloque
          referencias: {
            Banorte: esDiploma ? refDiplomasStr : refBaseStr,
            BBVA: esDiploma ? refDiplomasBBVA : refBaseBBVA 
          }
        };
      });

      setMensajeError("Límite de conceptos para pago en línea superado. Puedes descargar tu formato para pagar en ventanilla bancaria.");
      cambiarError(true);

    } else {
      if (tablaDesglose.length > 0) {
        const clavesTodas = tablaDesglose.map(item => item.clave);
        const datosRefUnica = generarLineaCaptura(plantelOficialAlumno, clavesTodas, matriculaStr, total);
        const folioUnico = generarFolioTPV();
        setFechaVencimiento(datosRefUnica.banorte.fechaVencimientoStr);

        tablaDesglose = tablaDesglose.map((item, idx) => ({
          ...item,
          id: idx + 1,
          folioTPV: folioUnico,
          referencias: {
            Banorte: datosRefUnica.banorte.lineaDeCaptura,
            BBVA: datosRefUnica.bancomer.lineaDeCaptura 
          }
        }));
      }
      cambiarError(false);
      setMensajeError("");
    }

    cambiarTablaConceptos(tablaDesglose);
    // La seleccion cambio -> nuevas referencias -> hay que poder guardarlas
    // de nuevo (el candado solo evita repetir el guardado por clics extra
    // sobre la MISMA seleccion).
    setIntencionGuardada(false);
  }, [conceptosSeleccionados, numDiplomas, alumno.codigo]);

  const PrepararPagoVentanilla = async () => {
    if (!intencionGuardada) {
      if (esSoloVentanilla) {
        const itemsBase = tablaConceptos.filter(item => ["04", "37", "38"].includes(item.clave));
        const itemsDiplomas = tablaConceptos.filter(item => item.clave === "11");

        if (itemsBase.length > 0) {
          const folioBase = itemsBase[0].folioTPV || generarFolioTPV();
          const importeBase = itemsBase.reduce((sum, item) => sum + Number(item.precio), 0);
          await guardarIntencionBD(itemsBase, importeBase, itemsBase[0].referencias.Banorte, itemsBase[0].referencias.BBVA, folioBase, "VENTANILLA");
        }

        if (itemsDiplomas.length > 0) {
          const folioDiplomas = itemsDiplomas[0].folioTPV || generarFolioTPV();
          const importeDiplomas = itemsDiplomas.reduce((sum, item) => sum + Number(item.precio), 0);
          await guardarIntencionBD(itemsDiplomas, importeDiplomas, itemsDiplomas[0].referencias.Banorte, itemsDiplomas[0].referencias.BBVA, folioDiplomas, "VENTANILLA");
        }
      } else {
        const folioUnico = tablaConceptos[0]?.folioTPV || generarFolioTPV();
        const refUnicaBanorte = tablaConceptos[0]?.referencias?.Banorte || "S/R";
        const refUnicaBBVA = tablaConceptos[0]?.referencias?.BBVA || "S/R";
        await guardarIntencionBD(tablaConceptos, precio, refUnicaBanorte, refUnicaBBVA, folioUnico, "VENTANILLA");
      }
      setIntencionGuardada(true);
    }

    await descargarPdf(tablaConceptos, null, fechaVencimiento);
  };

  const CrearPagoOnline = async () => {
    if (precio === 0) {
      setMensajeError("Debes seleccionar al menos un concepto.");
      cambiarError(true);
      return;
    }
    const refM97 = tablaConceptos[0]?.referencias?.Banorte; 
    const importe = precio.toString().concat(".00");

    try {
      let base64 = await ReferenciaOnline(refM97, importe);
      cambiarDatosPago({
        referencia: refM97,
        importe: importe,
        key: base64,
        fechaVencimiento: fechaVencimiento
      });
      cambiarPagar(true);
      history.push("/formadepago");
    } catch (err) {
      setMensajeError("Error de conexión. Inténtalo más tarde.");
      cambiarError(true);
    }
  };

  return alumno.codigo === "" ? (
    <Redirect to="/login" />
  ) : (
    <div className="FormularioDiplomas-container container">
      <button className="FormularioDiplomas-btn-regresar" onClick={() => history.push("/tipo")}>
        &larr; Regresar
      </button>

      <div className="FormularioDiplomas-main-header">
        <h2>Paquete de Egresados</h2>
        <p className="main-subtitle">Si no requieres todos los documentos oficiales, puedes desmarcar los que no necesites para personalizar tu pago.</p>
      </div>
      
      <div className="FormularioDiplomas-card">
        {esPaqueteCompleto ? (
          <div className="FormularioDiplomas-package-header">
            <h3>Costo Base <span>${Number(cPaqueteBase.precio).toFixed(2)}</span></h3>
            <p className="package-instruction-text">Este paquete incluye por defecto los siguientes documentos:</p>
          </div>
        ) : (
          <div className="FormularioDiplomas-package-header">
            <div className="custom-card-title-row">
              <h3>Selección Personalizada</h3>
              <span className="badge-max-concepts">Máximo 5 permitidos en línea</span>
            </div>
            <p className="package-instruction-text">Has desmarcado el paquete base. Selecciona individualmente los documentos que requieras:</p>
          </div>
        )}

        <hr className="FormularioDiplomas-divider" />
        
        <div className="FormularioDiplomas-checkbox-group">
          <label className="custom-egreso-checkbox">
            <input type="checkbox" name="certificado" checked={conceptosSeleccionados.certificado} onChange={handleCheckboxChange} />
            <span className="custom-checkmark"></span>
            <span className="checkbox-label-text">{cCertificado.concepto}</span>
            {!esPaqueteCompleto && <span className="individual-price">${Number(cCertificado.precio).toFixed(2)}</span>}
          </label>

          <label className="custom-egreso-checkbox">
            <input type="checkbox" name="servicioSocial" checked={conceptosSeleccionados.servicioSocial} onChange={handleCheckboxChange} />
            <span className="custom-checkmark"></span>
            <span className="checkbox-label-text">{cServicio.concepto}</span>
            {!esPaqueteCompleto && <span className="individual-price">${Number(cServicio.precio).toFixed(2)}</span>}
          </label>

          <label className="custom-egreso-checkbox">
            <input type="checkbox" name="noAdeudo" checked={conceptosSeleccionados.noAdeudo} onChange={handleCheckboxChange} />
            <span className="custom-checkmark"></span>
            <span className="checkbox-label-text">{cNoAdeudo.concepto}</span>
            {!esPaqueteCompleto && <span className="individual-price">${Number(cNoAdeudo.precio).toFixed(2)}</span>}
          </label>
        </div>
      </div>

      <div className="FormularioDiplomas-flex">
        <div className="FormularioDiplomas-form">
          <p className="diplomas-title">¿Cuántos Diplomas de Competencias adicionales deseas? <span className="diplomas-sub">(${Number(cDiploma.precio).toFixed(2)} c/u)</span></p>
          <div className="FormularioDiplomas-radios">
            {[0, 1, 2, 3, 4, 5].map((num) => (
              <label key={num} className="radio-option">
                <input type="radio" name="diplomas" value={num} checked={numDiplomas === num} onChange={(e) => setNumDiplomas(parseInt(e.target.value, 10))} />
                {num === 0 ? "Ninguno" : num}
              </label>
            ))}
          </div>
        </div>

        <div className="FormularioDiplomas-paybox">
          <div className="FormularioDiplomas-total">
            <h4>Total: <span>${Number(precio).toFixed(2)}</span></h4>
          </div>
          
          {error && <div className="Formulario-error"><p>{mensajeError}</p></div>}
          
          {esSoloVentanilla ? (
            <input 
              className="Formulario-boton" 
              type="button" 
              onClick={PrepararPagoVentanilla} 
              value={cargandoPdf ? "PROCESANDO FORMATO..." : "DESCARGAR FORMATO VENTANILLA"} 
              disabled={cargandoPdf}
            />
          ) : (
            <input className="Formulario-boton" type="button" onClick={CrearPagoOnline} value="CONTINUAR" />
          )}
        </div>
      </div>
    </div>
  );
};

export default FormularioDiplomas;